export const TableBody = ({ children }) => <tbody>{children}</tbody>;
